<template>
  <div class="privacy-policy">
    <mouse-pointer />
    <VueScrollProgressBar backgroundColor="#87A18D"></VueScrollProgressBar>
    <div class="header">
      <img src="../assets/images/logo.svg" />
    </div>
    <article class="container">
      <h1>Privacy Policy</h1>
      <br>
      <p>
        <strong
          >READ THIS POLICY CAREFULLY BEFORE BROWSING THIS WEBSITE OR USING ANY
          OF THE SERVICES. YOUR CONTINUED USE OF THIS WEBSITE INDICATES THAT YOU
          HAVE BOTH READ AND AGREE TO THE TERMS OF THIS PRIVACY POLICY. YOU
          CANNOT USE THIS WEBSITE IF YOU DO NOT ACCEPT THIS POLICY. ALL SECTIONS
          OF THIS POLICY ARE APPLICABLE TO BOTH MEMBERS AND GUESTS UNLESS THE
          SECTION EXPRESSLY STATES OTHERWISE.
        </strong>
      </p>
      <br />
      <ol>
        <li>
          Consultancy Squad Privacy Policy
          <ol>
            <li>
              For the purposes of this section, Personal Information will be
              understood in accordance with the definition provided in the
              Protection of Personal Information Act 4 of 2013 ("the Act").
              Consultancy Squad also subscribes to the principles for
              electronically collecting personal information outlined in the
              Act, and the further legislation referred to therein. We endeavour
              to ensure the quality, accuracy and confidentiality of Personal
              Information in our possession.
            </li>
            <br />
            <li>
              In adopting this Privacy Policy, we wish to balance our legitimate
              business interests and your reasonable expectation of privacy.
              Accordingly, we will take all reasonable steps to prevent
              unauthorised access to, or disclosure of your Personal
              Information. However, it is impossible to guarantee that your
              Personal Information shall be 100% secure.
            </li>
            <br />
            <li>
              When making use of the Website, users may&nbsp;be asked to provide
              the following information (Personal Information):
              <br />
              <ol>
                <li>First name.</li>
                <li>Physical address.</li>
                <li>Phone number.</li>
                <li>Company / CC / business name.</li>
              </ol>
            </li>
            <li>
              We will attempt to limit the types of Personal Information we
              process to only that to which you consent to (for example, in the
              context of online registration, newsletters, message boards,
              surveys, polls, professional announcements, SMS, MMS and other
              mobile services), but, to the extent necessary, your agreement to
              these this Privacy Policy constitutes your consent as contemplated
              in section 69 of the Act.
            </li>
            <br />
            <li>
              We will not collect, use or disclose sensitive information (such
              as information about racial or ethnic origins or political or
              religious beliefs, where relevant) except with your specific
              consent or in the circumstances permitted by law.
            </li>
            <br />
            <li>
              By agreeing to the terms contained in this Privacy Policy, you
              consent to the use of your Personal Information in relation to:
              <ol>
                <li>The provision and performance of the services;</li>
                <li>Informing you of changes made to our website;</li>
                <li>
                  The provision of marketing related services to you by
                  Consultancy Squad;
                </li>
                <li>Responding to any queries or requests you may have;</li>
                <li>
                  Developing a more direct and substantial relationship with
                  users for the purposes described in this clause;
                </li>
                <li>Developing an online user profile;</li>
                <li>
                  Understanding general user trends and patterns so that we can
                  develop and support existing and ongoing marketing strategies;
                </li>
                <li>For security, administrative and legal purposes; and</li>
                <li>
                  The creation and development of market data profiles which may
                  provide insight into market norms, practices and trends to
                  help us improve our offering to you. Such information will be
                  compiled and retained in aggregated form, but shall not be
                  used in any way which may comprise the identity of a user.
                </li>
              </ol>
            </li>
            <li>
              Although absolute security cannot be guaranteed on the internet,
              Consultancy Squad has in place up-to-date, reasonable technical
              and organisational security measures to protect your Personal
              Information against accidental or intentional manipulation, loss,
              misuse, destruction or against unauthorised disclosure or access
              to the information we process online.
            </li>
            <br />
            <li>
              While we cannot ensure or warrant the security of any Personal
              Information you provide us, we will continue to maintain and
              improve these security measures over time in line with legal and
              technological developments.
            </li>
            <br />
            <li>
              We store your Personal Information directly, or alternatively,
              store your Personal Information on, and transfer your Personal
              Information to, a central database. If the location of the central
              database is located in a country that does not have substantially
              similar laws which provide for the protection of Personal
              Information, we will take the necessary steps to ensure that your
              Personal Information is adequately protected in that jurisdiction.
            </li>
            <br />
            <li>
              Your information will not be stored for longer than is necessary
              for the purposes described in these Terms or as required by
              applicable legislation.
            </li>
            <br />
            <li>
              The Personal Information Consultancy Squad collects from users
              shall only be accessed by Consultancy Squad employees,
              representatives and consultants on a need-to-know basis, and
              subject to reasonable confidentiality obligations binding such
              persons.
            </li>
            <br />
            <li>
              Consultancy Squad shall have the right, but shall not be obliged,
              to monitor or examine any information and materials including any
              website link that you publish or submit to Consultancy Squad for
              publishing on the Site. You shall be solely responsible for the
              contents of all material published by yourself.
            </li>
            <br />
            <li>
              We constantly review our systems and data to ensure the best
              possible service to our users. We do not accept any users, or
              representatives of users, under 18 years of age or who otherwise
              does not have the relevant capacity to be bound by this Privacy
              Policy.
            </li>
            <br />
            <li>
              We will not sell, share, or rent your Personal Information to any
              third party or use your e-mail address for unsolicited mail. Any
              emails sent by Consultancy Squad will only be in connection with
              the provision of our services and/or the marketing thereof.
            </li>
          </ol>
          <br />
          <li>Log Files
            <ol>
              <li>When you visit Consultancy Squad, even if you do not create an account, we may collect information, such as your IP address, the name of your ISP (Internet Service Provider), your browser, the website from which you visit us, the pages on our website that you visit and in what sequence, the date and length of your visit, and other information concerning your computer's operating system, language settings, and broad demographic information. This information is aggregated and anonymous data and does not identify you specifically. However, you acknowledge that this data may be able to be used to identify you if it is aggregated with other Personal Information that you supply to us. This information is not shared with third parties and is used only within Consultancy Squad on a need-to-know basis. Any individually identifiable information related to this data will never be used in any way different to that stated above, without your explicit permission.</li>
            </ol>
          </li>
          <li>Cookies
            <ol>
              <li>Consultancy Squad uses cookies. A cookie is a small piece of information stored on your computer or smart phone by the web browser. The two types of cookies used on the Website are described below:</li>
              <ol>
                <li>"Session cookies": These are used to maintain a so-called 'session state' and only lasts for the duration of your use of the Website. A session cookie expires when you close your browser, or if you have not visited the server for a certain period of time. Session cookies are required for the Platform to function optimally, but are not used in any way to identify you personally.</li>
                <br>
                <li>"Double Click Cookies" Third party vendors with whom we contract may use cookies to serve a user ads based on a user's prior visits to the Website. Users may, however, opt out of receiving these ads by visiting www.aboutads.info.</li>
                <br>
                <li>"Permanent cookies": These cookies permanently store a unique code on your computer or smart device hard drive in order to identify you as an individual user. No Personal Information is stored in permanent cookies. You can view permanent cookies by looking in the cookies directory of your browser installation. These permanent cookies are not required for the Consultancy Squad website to work, but may enhance your browsing experience.</li>
                <br>
              </ol>
            </ol>
          </li>
          <li>
            <ol>
              <li>Consultancy Squad, and the services available through the Website, may contain links to other third party websites, including (without limitation) social media platforms, payment gateways, appointment scheduling and/or live chat platforms ("Third Party Websites").  If you select a link to any Third Party Website, you may be subject to such Third Party Website's terms and conditions and/or other policies, which are not under the control, nor responsibility, of Consultancy Squad.</li>
              <br>
              <li>Hyperlinks to Third Party Websites are provided "as is", and Consultancy Squad does not necessarily agree with, edit or sponsor the content on Third Party Websites.</li>
              <br>
              <li>Consultancy Squad does not monitor or review the content of any Third Party Website. Opinions expressed or material appearing on such websites are not necessarily shared or endorsed by us and we should not be regarded as the publisher of such opinions or material. Please be aware that we are not responsible for the privacy practices, or content, of other websites, either. </li>
              <br>
              <li>Users should evaluate the security and trustworthiness of any Third Party Website before disclosing any personal information to them. Consultancy Squad does not accept any responsibility for any loss or damage in whatever manner, howsoever caused, resulting from your disclosure to third parties of personal information.</li>
              <br>
            </ol>
          </li>
          <li>
            Application Of The Electronic Communications And Transactions Act 25 Of 2002 ("Ect Act")
            <ol>
              <li>Data Messages (as defined in the ECT Act) will be deemed to have been received by Consultancy Squad if and when Consultancy Squad responds to the Data Messages.</li>
              <br>
              <li>Data Messages sent by Consultancy Squad to a user will be deemed to have been received by such user in terms of the provisions specified in section 23(b) of the ECT Act.</li>
              <br>
              <li>Users acknowledge that electronic signatures, encryption and/or authentication are not required for valid electronic communications between users and Consultancy Squad.</li>
              <br>
              <li>Information to be provided in terms of section 43(1) of the ECT Act:
                <br>
                <ol>
                  <li>Users warrant that Data Messages sent to Consultancy Squad from any electronic device, used by such user, from time to time or owned by such user, were sent and or authorised by such user, personally.</li>
                  <li>This Website is owned and operated by Consultancy Squad (Pty) Ltd, (Registration Number: 2020/483281/07) a private company owned and operated in accordance with the laws of the Republic of South Africa.</li>
                </ol>
              </li>
              <br>
              <li>Address for service of legal documents: 12 Suikerriet street, Nelspruit, Mpumalanga,  South Africa.</li>
              <br>
              <li>Contact Number: 0825121349.</li>
              <br>
              <li>Consultancy Squad - located at <a href="www.consultancysquad.co.za">www.consultancysquad.co.za</a></li>
              <br>
              <li>Email address: <a href="mailto:hi@consultancysquad.co.za">hi@consultancysquad.co.za</a></li>
              <br>
            </ol>
          </li>
      </ol>
    </article>
  </div>
</template>

<script>
import { VueScrollProgressBar } from '@guillaumebriday/vue-scroll-progress-bar'
import mousePointer from '@/components/mouse-pointer'
export default {
  name: 'Home',
  components: {
    VueScrollProgressBar,
    'mouse-pointer': mousePointer
  }
}
</script>

<style lang="scss">
@import "../assets/styles/breakpoints";
@import "../assets/styles/variables";
.privacy-policy {
  .header {
    height: 100px;
    padding: 1rem;
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    background: $white;
    box-shadow: 0px -4px 10px 4px #828282;
    @include breakpoint(md) {
      height: 75px;
    }
  }
  article {
    margin-top: 50px;
    padding-bottom: 125px;
    @include breakpoint(sm) {
      margin-top: 50px;
    }
    ol {
      display: block;
      list-style-type: decimal;
      padding: 0;
      counter-reset: item;
      padding-inline-start: 20px;
      ol {
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 10px;
        li {
          font-weight: initial;
          display: block;
          counter-increment: item;
          text-align: -webkit-match-parent;
          content: counters(item, ".") " ";
          &:before {
            content: counters(item, ".") " ";
          }
          ol {
            margin-block-start: 1em;
            margin-block-end: 1em;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
            padding-inline-start: 20px;
            li {
              display: block;
              counter-increment: item;
              text-align: -webkit-match-parent;
              content: counters(item, ".") " ";
              &:before {
                content: counters(item, ".") " ";
              }
            }
          }
        }
      }
      li {
        font-weight: bold;
        counter-increment: item;
        content: counters(item, ".") ".";
      }
    }
    p {
      font-size: 13px;
    }
    h1 {
      font-size: 60px;
      color: $sage;
      text-align: center;
      font-family: "Autography", Courier, monospace;
    }
    @include breakpoint(sm) {
      font-size: 40px;
    }
  }
}
</style>
